export default __webpack_public_path__ + "static/media/car1.9d262ab5.jpeg";